import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, BrowserRouter as Router, Route, Link } from "react-router-dom";
function CMDeactiveCustomer() {
    const [loading, setLoading] = useState(true);
    const [stbCount, setStbCount] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);

    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ area_code: "", network: "", date: "", toDate: "" })
    const initialFormData = { area_code: "", network: "", date: "", toDate: "" }
   
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
   const downloadCSV = () => {
  const headers = [
    "Sno", "Customer_Name", "Acc_no", "Code", "STB_no", "Door_no", "Flat_name",
    "Street_name", "Phone", "Pay_Status", "Plan_Amount", "Paid_Amount", "Paid_Date",
    "Balance_Amount", "Discount_Amount", "Advance_Amount", "Pending_Amount",
    "Staff_Code", "Network", "Paid_time", "Package", "Added_date", "Collection_Staff"
  ];

  const csvRows = [];
  csvRows.push(headers.join(",")); // header row


     allCustomer.forEach((row, index) => {
    const values = [
      index + 1, 
      row.name,
      row.account_num,
      row.acc_num,
      row.serial_num,
      row.doorno,
      row.flat_name,
      row.street,
      row.mobile,
      row.status,
      row.pay_amt,
      row.paid_amt,
      row.paid_date,
      row.balance_amt,
      row.discount,
      row.extra_balance_amt,
      row.pend_amt,
      row.area_code,
      row.net_name,
      row.paid_time,
      row.package,
      row.adate,
      row.col_boy
    ];

    // Properly escape and wrap every value
    const safeValues = values.map(v => {
      const str = v == null ? "" : String(v).replace(/"/g, '""'); // escape quotes
      return `"${str}"`; // wrap with double quotes
    });

    csvRows.push(safeValues.join(","));
  });

  const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "CMDeactivecustomer.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allCustomer.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(allCustomer.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    const handleClear = () => { setFormData(initialFormData); };

    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/cmDeactiveGetInfo', { user });
            if (response.status === 200) {

                setStbCount(response.data.allCustomer.length);

                setAllCustomer(response.data.allCustomer);
            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };
    const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);
    const handleCopyToClipboard = () => { navigator.clipboard.writeText(stb).then(() => { toast.info(`${stbCount} STB numbers copied`); }).catch((error) => { toast.warning("not copied: " + error); }); };
    useEffect(() => { fetchUserData(); }, []);
    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return <div className='d-flex justify-content-center align-items-center min-vh-100'>Error: {error}</div>;
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4 ">Current Month Customer Details</div>

                </div>
                <hr />
                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn py-2">
                        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                            <h4 className="text-navy h5">Customer Details</h4>
                            <div className="input-group w-25">
                                <input type="text" className="form-control text-navy bg-light border-0 h-50 px-2" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                <span
                                    className="input-group-text bg-light text-navy border-0 px-2"
                                    id="basic-addon1"
                                    style={{ borderRadius: "0 5px 5px 0" }}
                                >
                                    <i className="fas fa-search" />
                                </span>
                            </div>
                            {/* Actions */}
                            <div className="d-flex flex-column flex-md-row align-items-center ">


                                <div className="d-flex justify-content-end btn-group">
                                    <button onClick={downloadCSV} className="btn py-1 btn-dark border-right"><i className="fas fa-file-excel" />&nbsp;Excel Download</button>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="card-body p-0">
                        <table id="myTable" className="table table-striped bg-white table-bordered table-responsive-lg" style={{ backgroundColor: "rgba(151, 151, 151, 0.185)" }}>
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sno</th>
                                    <th >Customer__Name</th>
                                    <th>Acc_no</th>
                                    <th>Code</th>
                                    <th>STB_no</th>
                                    <th className='text-center px-5'>Network</th>
                                    <th>Door_no</th>
                                    <th>Flat_name</th>
                                    <th className='text-center px-5'>Street__name</th>
                                    <th>Phone</th>
                                    <th>Connection Date</th>
                                    <th>Payment Status</th>
                                    <th>Plan Amount</th>
                                    <th>Advance Amount</th>
                                    <th>Packages</th>
                                    <th>Connection Status</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index}>
                                            <td className='tableText border-dark text-bold'>{indexOfFirstRow + index + 1}</td>
                                            <td className='tableText border-dark text-bold'>{row.name}</td>
                                            <td className='tableText border-dark text-bold'>{row.account_num}</td>
                                            <td className='tableText border-dark text-bold'>{row.acc_num}</td>
                                            <td className='tableText border-dark text-bold'>{row.serial_num}</td>
                                            <td className='tableText border-dark text-bold'>{row.net_name}</td>
                                            <td className='tableText border-dark text-bold'>{row.doorno}</td>
                                            <td className='tableText border-dark text-bold'>{row.flat_name}</td>
                                            <td className='tableText border-dark text-bold'>{row.street}</td>
                                            <td className='tableText border-dark text-bold'>{row.mobile}</td>  
                                            <td className='tableText border-dark text-bold'>{row.new_con_date}</td>
                                            <td className='tableText border-dark text-bold'>{row.status}</td>
                                            <td className='tableText border-dark text-bold'>{row.pay_amt}</td>
                                            <td className='tableText border-dark text-bold'>{row.extra_Balance_amt}</td>
                                            <td className='tableText border-dark text-bold'>{row.package}</td>
                                            <td>
                                                {row.con_status === "active" || row.con_status === "Active" ? (
                                                    <button className="btn btn-success">Deactive</button>
                                                ) : row.con_status === "active" || row.con_status === "Active" ? (
                                                    <div className="d-flex-column"><button className="btn btn-danger">deactive </button></div>
                                                ) : (
                                                    <div className="d-flex-column"><button className="btn btn-danger">{row.con_status}</button></div>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr className='bg-white'>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-light">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default CMDeactiveCustomer;
